import { MouseEvent, MouseEventHandler, ReactNode } from "react";
import { LinkProps } from "@mui/material";
import { NeutralAnchor } from "./NeutralAnchor";

interface Props extends Pick<LinkProps, "onKeyDown" | "tabIndex"> {
  children: ReactNode;
  href: string;
  onClick?: MouseEventHandler;
}

/**
 * Avoids full Next.js render routing, currently used on filters/pagination (query params changes).
 */
export function SeoAnchor({ children, href, onClick, ...props }: Props) {
  const handleClick = (e: MouseEvent) => {
    e.preventDefault();
    onClick && onClick(e);
  };

  return (
    <NeutralAnchor href={href} onClick={handleClick} {...props}>
      {children}
    </NeutralAnchor>
  );
}
